<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.change')"
      :width="$selectByLang('340px', '380px')"
      class="change-order-dialog"
      :close-on-click-modal="false"
      :show-close="true"
      @close="cancel"
    >
      <div>
        <el-form :label-width="$selectByLang('90px', '130px')" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_ExpectedReturnDate')">
            <el-date-picker
              v-model="estimatedDeliveryDate"
              no="estimatedDeliveryDate"
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right; margin-top: 20px">
          <el-button no="confirm" type="primary" @click="saveHandler">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="cancel" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'ChangeOrderWindow',
  components: { },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      options: {
        columnApi: null
      },
      estimatedDeliveryDate: ''
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  methods: {
    cancel() {
      this.estimatedDeliveryDate = ''
      this.$emit('close')
    },
    saveHandler() {
      this.$emit('changeOrderHandler', this.estimatedDeliveryDate)
      this.cancel()
    }
  }
}
</script>
<style scoped>

</style>

